import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../assets/config';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title fade-in-up">
              Transform Your Space with
              <span className="highlight"> Musespace</span>
            </h1>
            <p className="hero-subtitle fade-in-up">
              Professional architecture and interior design services that bring your vision to life
            </p>
            <div className="hero-actions fade-in-up">
              <Link to="/portfolio" className="btn btn-primary">
                View Our Work
              </Link>
              <Link to="/contact" className="btn btn-secondary">
                Get Quote
              </Link>
            </div>
            <div className="hero-stats fade-in-up">
              <div className="stat">
                <span className="stat-number">20+</span>
                <span className="stat-label">Projects</span>
              </div>
              <div className="stat">
                <span className="stat-number">4+</span>
                <span className="stat-label">Years</span>
              </div>
              <div className="stat">
                <span className="stat-number">20+</span>
                <span className="stat-label">Happy Clients</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="section services-preview">
        <div className="container">
          <div className="section-title">
            <h2>Our Services</h2>
            <p>Comprehensive design solutions for residential and commercial spaces</p>
          </div>
          <div className="grid grid-3">
            {siteConfig.services.map((service, index) => (
              <div key={index} className="service-card card fade-in-up">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-4">
            <Link to="/services" className="btn btn-primary">
              View All Services
            </Link>
          </div>
        </div>
      </section>

      {/* About Preview */}
      <section className="section about-preview">
        <div className="container">
          <div className="grid grid-2">
            <div className="about-content">
              <h2>{siteConfig.about.title}</h2>
              <p>{siteConfig.about.description}</p>
              <div className="highlights">
                {siteConfig.about.highlights.map((highlight, index) => (
                  <div key={index} className="highlight-item">
                    <span className="highlight-icon">✓</span>
                    <span>{highlight}</span>
                  </div>
                ))}
              </div>
              <Link to="/about" className="btn btn-primary">
                Learn More
              </Link>
            </div>
            <div className="about-image">
              <div className="image-placeholder">
                <span>🏗️</span>
                <p>Professional Architecture & Design</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="section contact-cta">
        <div className="container">
          <div className="cta-content text-center">
            <h2>Ready to Start Your Project?</h2>
            <p>Get in touch with us to discuss your vision and get a free consultation</p>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon">📧</span>
                <div>
                  <strong>Email</strong>
                  <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
                </div>
              </div>

              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <div>
                  <strong>Address</strong>
                  <span>{siteConfig.contact.address}</span>
                </div>
              </div>
            </div>
            <div className="cta-actions">
              <Link to="/contact" className="btn btn-primary">
                Get Free Consultation
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 